module.exports = __webpack_public_path__ + "static/media/temp_39.bc88f3e1.jpg";